// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import { themeCssVar as globalTheme } from '../../utils/theme';

import { ButtonColors } from './types';

const COLOR_TRANSPARENT = 'transparent';

export const Primary: ButtonColors = {
  background: globalTheme.gradient.backgroundButtonPrimary,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonPrimary,
  overlay: globalTheme.color.interactiveButtonPrimary,
  focus: globalTheme.color.borderFocusDefault,
};

export const PrimaryAccessible: ButtonColors = {
  ...Primary,
  background: globalTheme.color.backgroundButtonPrimarySmall,
};

export const PrimaryOverlay: ButtonColors = {
  ...Primary,
  background: globalTheme.color.backgroundButtonPrimaryOverlay,
  foreground: globalTheme.color.foregroundButtonPrimaryOverlay,
};

export const Secondary: ButtonColors = {
  background: COLOR_TRANSPARENT,
  border: globalTheme.color.borderButtonSecondary,
  foreground: globalTheme.color.foregroundButtonSecondary,
  overlay: globalTheme.color.interactiveButtonSecondary,
  focus: globalTheme.color.borderFocusDefault,
};

export const SecondaryOverlay: ButtonColors = {
  ...Secondary,
  border: globalTheme.color.borderButtonSecondaryOverlay,
  foreground: globalTheme.color.foregroundButtonSecondaryOverlay,
};

export const Tertiary: ButtonColors = {
  background: COLOR_TRANSPARENT,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonTertiary,
  overlay: globalTheme.color.interactiveButtonTertiary,
  focus: globalTheme.color.borderFocusDefault,
};

export const TertiaryOverlay: ButtonColors = {
  ...Tertiary,
  foreground: globalTheme.color.foregroundButtonTertiaryOverlay,
};

export const Neutral: ButtonColors = {
  background: globalTheme.color.backgroundButtonNeutral,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonNeutral,
  overlay: globalTheme.color.interactiveButtonNeutral,
  focus: globalTheme.color.borderFocusDefault,
};

export const PrimaryGold: ButtonColors = {
  background: globalTheme.gradient.backgroundGold,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonPrimaryOverlay,
  overlay: globalTheme.color.interactiveButtonPrimary,
  focus: globalTheme.color.borderFocusDefault,
};

export const PrimaryPlatinum: ButtonColors = {
  background: globalTheme.gradient.backgroundPlatinum,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundPrimaryInverse,
  overlay: globalTheme.color.interactiveButtonPrimary,
  focus: globalTheme.color.borderFocusDefault,
};

export const PrimarySelect: ButtonColors = {
  background: globalTheme.gradient.backgroundVaultGradient,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonPrimary,
  overlay: globalTheme.color.interactiveButtonPrimary,
  focus: globalTheme.color.borderFocusDefault,
};

export const PrimarySuperLike: ButtonColors = {
  background: globalTheme.gradient.backgroundSuperLike,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonPrimaryOverlay,
  overlay: globalTheme.color.interactiveButtonPrimary,
  focus: globalTheme.color.borderFocusDefault,
};

export const PrimaryBoost: ButtonColors = {
  background: globalTheme.gradient.backgroundBoost,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonPrimary,
  overlay: globalTheme.color.interactiveButtonPrimary,
  focus: globalTheme.color.borderFocusDefault,
};

export const PrimarySuperBoost: ButtonColors = {
  background: globalTheme.gradient.backgroundSuperBoost,
  border: COLOR_TRANSPARENT,
  foreground: globalTheme.color.foregroundButtonPrimary,
  overlay: globalTheme.color.interactiveButtonPrimary,
  focus: globalTheme.color.borderFocusDefault,
};
